module.exports = __webpack_public_path__ + "static/media/hamd.d0e00863.png";